// extracted by mini-css-extract-plugin
module.exports = {"container":"_03s","icon":"cKim","title":"__5rW6","description":"Z4fB"};